import {createAction, props} from '@ngrx/store';
import {Client, User} from '../../../../core/models/models';

export const login = createAction(
  '[Auth] login',
  props<{ username: string, password: string }>()
);

export const loginBySmsCode = createAction(
  '[Auth] login by sms code',
  props<{ phone: string, code: string }>()
);

export const loginUserBySmsCode = createAction(
  '[Auth] login user by sms code',
  props<{ phone: string, code: string }>()
);

export const authError = createAction(
  '[Auth] Error',
  props<{ error: string }>()
);

export const setToken = createAction(
  '[Auth] Set token',
  props<{ token: string }>()
);

export const loginSuccess = createAction(
  '[Auth] login success',
  props<{ user: User, url: string, queryParams?: any }>()
);

export const loginByToken = createAction(
  '[Auth] Login by token',
  props<{url: string, queryParams?: any}>()
);

export const loginByAuthCode = createAction(
  '[Auth] Login by auth code',
  props<{auth_code: string, url: string}>()
);

export const logout = createAction(
  '[Auth] logout'
);

export const logoutSuccess = createAction(
  '[Auth] logout success'
);

export const setUserType = createAction(
  '[Auth] Set user type',
  props<{ user_type: string }>()
);

export const registerUser = createAction(
  '[Auth] Register user',
  props<{ user: User }>()
);

export const registerFinish = createAction(
  '[Auth] Register user finish'
);

export const checkCode = createAction(
  '[Auth] Check Code',
  props<{ code: string }>()
);

export const checkCodeSuccess = createAction(
  '[Auth] Check Code success'
);

export const resendCode = createAction(
  '[Auth] Resend Code'
);

export const resendCodeSuccess = createAction(
  '[Auth] Resend Code success'
);

export const updateUserInfo = createAction(
  '[Auth] Update user info',
  props<{user: User & Client}>()
);


